// import { FormDataHubAdjustmentTaxInvoice } from '@/form/form-data/FormDataHubAdjustmentTaxInvoice';
import { getInitialState } from '@/vuex-store/hub-adjustment/tax-invoice-dialog/state';
import { setFormData } from '@/utils/vueUtils';
import HubAdjustmentTaxInvoiceVM from '@/view-model/hub-adjustment/HubAdjustmentTaxInvoiceVM';
export const mutationType = {
    // 다이얼로그 열기/닫기
    SET_DIALOG_DETAIL: 'SET_DIALOG_DETAIL',
    // 다이얼로그 수정모드 변경
    SET_IS_EDIT_MODE: 'SET_IS_EDIT_MODE',
    // 세금계산서 조회
    GET_TAX_INVOICE_BY_ID: 'GET_TAX_INVOICE_BY_ID',
    // 수정 폼 업데이트
    UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
    // 수정 폼 초기화
    INIT_FORM_DATA: 'INIT_FORM_DATA',
    // 세금계산서 수정
    PUT_TAX_INVOICE_BY_ID: 'PUT_TAX_INVOICE_BY_ID',
    // 전체 초기화
    RESET_STORE: 'RESET_STORE',
};
const mutations = {
    [mutationType.SET_DIALOG_DETAIL](state, payload) {
        state.dialogDetail = payload;
    },
    [mutationType.SET_IS_EDIT_MODE](state, isEditMode) {
        state.isEditMode = isEditMode;
    },
    [mutationType.GET_TAX_INVOICE_BY_ID](state, data) {
        state.taxInvoiceData = new HubAdjustmentTaxInvoiceVM(data);
        state.invoicerFormData.initFormData(data);
    },
    [mutationType.INIT_FORM_DATA](state) {
        if (!state.taxInvoiceData?._taxInvoice) {
            return;
        }
        state.invoicerFormData.initFormData(state.taxInvoiceData?._taxInvoice);
    },
    [mutationType.UPDATE_FORM_DATA](state, { key, value, }) {
        setFormData(state.invoicerFormData, key, value);
    },
    [mutationType.PUT_TAX_INVOICE_BY_ID](state, data) {
        state.taxInvoiceData = new HubAdjustmentTaxInvoiceVM(data);
        state.invoicerFormData.initFormData(data);
    },
    [mutationType.RESET_STORE](state) {
        Object.assign(state, getInitialState());
    },
};
export default mutations;
